import { useRouter } from 'next/router';
import { LogoBlue } from '@components/icons';
import { Background, Nav, LogoWrapper, Container, StyledEm, StyledLink, StyledSpan } from './NavbarDesktop.styles';
import Link from 'next/link';
import ConnectWalletButton from '@components/common/navbar/ConnectWalletButton';
import DarkMode from '@components/common/navbar/DarkMode';

export default function NavbarDesktop() {
  // Used to style menu links for the "active page"
  return (
    <>
      <Background />
      <Nav>
        <LogoWrapper>
          <Link href="/">
            <LogoBlue />
          </Link>
        </LogoWrapper>
        <MenuLinks />
      </Nav>
    </>
  );
}

function MenuLinks() {
  const r = useRouter();
  return (
    <Container>
      <StyledLink href="/open-position" $isActive={r.pathname === '/open-position'}>
        <StyledSpan type="span">Open Position</StyledSpan>
        {r.pathname === '/open-position' && <StyledEm></StyledEm>}
      </StyledLink>
      <StyledLink href="/earn" $isActive={r.pathname === '/earn'}>
        <StyledSpan type="span">Earn</StyledSpan>
        {r.pathname === '/earn' && <StyledEm></StyledEm>}
      </StyledLink>
      <StyledLink href="https://dune.com/archimedesfi/liquidity-provider-dashboard" target="_blank" rel="noreferrer">
        <StyledSpan type="span">Analytics</StyledSpan>
      </StyledLink>
      <StyledLink href="/dashboard" $isActive={r.pathname === '/dashboard'}>
        <StyledSpan type="span">My Dashboard</StyledSpan>
        {r.pathname === '/dashboard' && <StyledEm></StyledEm>}
      </StyledLink>
      <ConnectWalletButton />
      {/* <DarkMode /> */}
    </Container>
  );
}
